import { Reducer } from 'redux'
import { ActionTypes, TViewedItemsActivityState } from './types'
import { getDataForPagination, getMapData } from '../../../../utils/reducerUtils'

export const initialState: TViewedItemsActivityState = {
  loading: false,
  data: null,
  childData: null,
}

const reducer: Reducer<TViewedItemsActivityState> = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.GET_VIEWED_ITEM_ACTIVITY_R:
      return { ...state, loading: true, errors: undefined }
    case ActionTypes.GET_VIEWED_ITEM_ACTIVITY_S:
      return { ...state, loading: false, errors: undefined, data: getDataForPagination(state.data, action.payload) }
    case ActionTypes.GET_VIEWED_ITEM_ACTIVITY_WITH_O_OFFSET_S:
      return { ...state, loading: false, errors: undefined, data: action.payload }
    case ActionTypes.GET_VIEWED_ITEM_ACTIVITY_E:
      return { ...state, loading: false, errors: action.payload, data: [] }

    case ActionTypes.GET_VIEWED_ITEM_ACTIVITY_CHILD_R:
      return { ...state, loading: true, errors: undefined }
    case ActionTypes.GET_VIEWED_ITEM_ACTIVITY_CHILD_S:
      return { ...state, loading: false, errors: undefined, childData: getMapData(state.childData, action.payload) }
    case ActionTypes.GET_VIEWED_ITEM_ACTIVITY_CHILD_E:
      return { ...state, loading: false, errors: action.payload }

    default:
      return state
  }
}

export { reducer as ViewedItemsActivityReducer }
